import React from 'react'
import {makeStyles} from '@material-ui/core/styles';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import Recaptcha from 'react-recaptcha'
import {ThemeProvider} from "@material-ui/styles";

const theme = createMuiTheme({
    typography: {
        fontFamily: [
            '"Lato"',
            '"Roboto"',
            'sans-serif'
        ].join(','),
    },
    palette: {
        primary: {
            main: '#28C339'
        }
    },
});

const useStyles = makeStyles(() => ({
    recaptcha: {
        marginTop: '10px',
        maxWidth: '80%',
        width: 'fit-content',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
}));

//https://www.google.com/recaptcha/admin/site/432522465 to add web URL/manage Captcha

const Captcha = ({setCaptchaPasses, captchaPasses}) => {
    const classes = useStyles();

    const verifyCallbackRecaptcha = () => {
        setCaptchaPasses(true)
    }

    const showCaptcha = () => {
        return (
            <Recaptcha
                sitekey="6LfhxMcZAAAAAI21JZR_atMrAJHHKEpvPAV4D9Wy"
                render="explicit"
                verifyCallback={()=>verifyCallbackRecaptcha()}
                className={classes.recaptcha}
            />
        )
    }


    return (
        <ThemeProvider theme={theme}>
            <div>
                {
                    !captchaPasses && (
                        <p style={{color: 'red'}}>Antes de enviar, asegúranos que no eres un robot. Disculpe las molestias</p>
                    )
                }
                {
                    showCaptcha()
                }

            </div>
        </ThemeProvider>
    )
}

export default Captcha
